import { HttpErrorService } from '~/services/HttpError.service'
import type { GroupOrderDto, OrderCalculated, OrderDto } from '~/models'
import { orderErrorHandbook } from '@/models'
import { HttpService } from '~/services/Http.service'

export class GroupOrderService {
  private httpErrorService: HttpErrorService<keyof typeof orderErrorHandbook>
  private endpoint = '/group-orders'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(orderErrorHandbook, 'order')
  }

  async calculate(order: { items: OrderDto[] }, secure: boolean) {
    const url = [this.endpoint, 'calculate'].join('/')

    return await this.httpService
      .post<OrderCalculated>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          secure,
        },
        fetchConfig: {
          body: order,
          params: {
            isSaleStepCheckDisabled: true,
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async create(order: { items: OrderDto[] }, secure: boolean) {
    const url = [this.endpoint, 'init'].join('/')

    return await this.httpService
      .post<OrderDto>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          secure,
        },
        fetchConfig: {
          body: order,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async get(slug: string) {
    const url = this.endpoint

    return await this.httpService
      .get<GroupOrderDto>(url, {
        requestConfig: {
          forceRequest: true,
          needGlobal404: true,
          secure: true,
        },
        fetchConfig: {
          params: {
            slug,
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
